@if (pageAllowed() | async) {
    @if (baseOrderId$ | async; as baseOrderId) {
        <div class="aimo-base-order-details">
            <aimo-base-order-details [baseOrderId]="baseOrderId"></aimo-base-order-details>
        </div>
    } @else {
        @if (breadcrumbs$ | async; as breadcrumbs) {
            <aimo-breadcrumb
                [hideTitle]="true"
                [showBackLink]="false"
                [addFrontPageLink]="false"
                [normalBreadCrumbs]="breadcrumbs">
            </aimo-breadcrumb>
        }

        <cx-page-slot position="TopContent"></cx-page-slot>

        @if (baseOrderList$ | async; as baseOrders) {
            <cx-page-slot position="PageDescription"></cx-page-slot>
            <div class="templates-search" [formGroup]="searchForm">
                <div class="row no-gutters align-items-center">
                    <div class="cx-search-criteria-find col-12 col-lg-4 mr-lg-3 order-lg-1 order-2 pb-3 pb-lg-0">
                        <aimo-cx-input
                            [inputClass]="'input-md mt-0'"
                            (afterChange)="fetchBaseOrders()"
                            [placeholder]="'aimo.baseOrders.search'"
                            [parentForm]="searchForm"
                            [nameForm]="'search'"
                            [inputIcon]="'icon-magnifying-glass icon-petrol-blue'">
                        </aimo-cx-input>
                    </div>
                    <div class="col-12 col-lg-auto ml-lg-auto order-lg-2 order-3">
                        <div class="d-flex justify-content-lg-end align-items-lg-center flex-column flex-lg-row">
                            <div class="aimo-sorting d-flex justify-content-end align-items-center">
                                <ng-select
                                    [id]="'sortField'"
                                    [bindLabel]="'code'"
                                    [bindValue]="'code'"
                                    [clearable]="false"
                                    [closeOnSelect]="true"
                                    [formControlName]="'sortField'"
                                    [items]="sortEntries"
                                    [multiple]="false"
                                    [searchable]="false"
                                    (change)="fetchBaseOrders()"
                                    class="text-left nowrap">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ 'aimo.baseorder.sort.' + item.code | cxTranslate }}
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        {{ 'aimo.baseorder.sort.' + item.code | cxTranslate }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-auto ml-lg-3 order-lg-3 order-1 pb-3 pb-lg-0">
                        <button
                            class="btn btn-sm btn-primary"
                            (click)="openCreateBaseOrderModal(); pushGtmEvent('baseorders-create-new-modal-open')">
                            <i class="icon-plus-circle icon-white icon-inline aimo-icon mr-2 mb-1"></i>
                            {{ 'aimo.baseOrders.button.create' | cxTranslate }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="aimo-order-templates-table">
                @for (baseOrder of baseOrders.carts; track baseOrder.code) {
                    <div
                        class="row no-gutters aimo-order-templates-row"
                        [ngClass]="{
                            'sales-blocked': baseOrder.salesBlocked,
                            unapproved: baseOrder.unApprovedChanges,
                        }">
                        <div class="col-lg-12">
                            <a class="link routerlink d-block" [routerLink]="'/baseorders/' + baseOrder.code">
                                <div class="row no-gutters align-items-center">
                                    <div class="col-lg-3 col-12 pb-2 pb-lg-0 d-flex align-items-center">
                                        @if (!baseOrder.salesBlocked) {
                                            <i class="aimo-icon icon-arrow-clockwise icon-inline icon-petrol-blue mr-2">
                                            </i>
                                        }
                                        @if (baseOrder.salesBlocked) {
                                            <i class="aimo-icon icon-prohibit icon-inline icon-mid-grey mr-2"> </i>
                                        }
                                        <h5 class="mb-0">
                                            {{ baseOrder.name }}
                                            @if (baseOrder.aboutToBeSalesBlocked) {
                                                <i
                                                    class="left-side aimo-icon icon-inline icon-warning-circle icon-red"></i>
                                            }
                                        </h5>
                                    </div>
                                    <div class="col-lg-5 col-6 d-none d-lg-flex aimo-order-templates-images">
                                        @for (
                                            entry of getSampleEntries(baseOrder);
                                            track entry.entryNumber;
                                            let i = $index
                                        ) {
                                            <div
                                                class="cx-product-image-container mr-2"
                                                [ngClass]="{ 'd-xl-inline-block d-lg-none': i > 2 }">
                                                <cx-media
                                                    class="cx-product-image"
                                                    [alt]="entry.product.name"
                                                    [title]="entry.product.name"
                                                    triggers="mouseenter:mouseleave"
                                                    popoverClass="popover-default"
                                                    container="body"
                                                    [ngbPopover]="entry.product.name"
                                                    [container]="entry.product?.images?.PRIMARY"
                                                    format="cartIcon">
                                                </cx-media>
                                            </div>
                                        }
                                        @if (baseOrder.entries.length > 4) {
                                            <div class="aimo-order-template-additional-images-box d-lg-flex d-xl-none">
                                                <div class="text-dark-grey">+ {{ baseOrder.entries.length - 3 }}</div>
                                            </div>
                                        }
                                        @if (baseOrder.entries.length > 6) {
                                            <div class="aimo-order-template-additional-images-box d-xl-flex d-lg-none">
                                                <div class="text-dark-grey">+ {{ baseOrder.entries.length - 5 }}</div>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-lg-4 col-12 align-items-center text-default">
                                        <div class="row">
                                            <div class="col-lg-4 col-4 d-flex align-items-center">
                                                <div class="mr-lg-2 mr-0">
                                                    @for (
                                                        weekday of baseOrder.weekDays;
                                                        track weekday;
                                                        let last = $last;
                                                        let first = $first
                                                    ) {
                                                        @if (first) {
                                                            <i
                                                                class="aimo-icon icon-calendar-blank icon-sm icon-petrol-blue icon-inline">
                                                            </i>
                                                        }
                                                        <span>{{
                                                            'aimo.calendar.weekday.short.' + weekday | cxTranslate
                                                        }}</span>
                                                        @if (!last) {
                                                            <span>, </span>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-4 d-flex align-items-center">
                                                <div class="mr-lg-2 mr-0">
                                                    <i
                                                        class="aimo-icon icon-arrow-clockwise icon-sm icon-petrol-blue icon-inline">
                                                    </i>
                                                    @if (baseOrder.oddWeek === true) {
                                                        <span>{{ 'aimo.select.evenOdd.odd' | cxTranslate }}</span>
                                                    }
                                                    @if (baseOrder.oddWeek === undefined) {
                                                        <span>{{ 'aimo.select.evenOdd.both' | cxTranslate }}</span>
                                                    }
                                                    @if (baseOrder.oddWeek === false) {
                                                        <span>{{ 'aimo.select.evenOdd.even' | cxTranslate }}</span>
                                                    }
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-4 d-flex align-items-center justify-content-end">
                                                <span class="product-count">
                                                    {{
                                                        'aimo.ordertemplates.products.' +
                                                            (baseOrder.entries?.length === 1 ? 'one' : 'many')
                                                            | cxTranslate: { amount: baseOrder.entries?.length }
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                }
            </div>
        }
        <cx-page-slot position="BottomContent"></cx-page-slot>
    }
}
